define(["exports", "./utils", "./pubsubhub"], function (_exports, _utils, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.sortListItems = sortListItems;
  _exports.sortDefinitionTerms = sortDefinitionTerms;
  _exports.run = run;
  _exports.name = void 0;
  // @ts-check
  const name = "core/list-sorter";
  _exports.name = name;

  function makeSorter(direction) {
    return ({
      textContent: a
    }, {
      textContent: b
    }) => {
      return direction === "ascending" ? a.localeCompare(b) : b.localeCompare(a);
    };
  }
  /**
   * Shallow sort list items in OL, and UL elements.
   *
   * @param {HTMLUListElement} elem
   * @returns {DocumentFragment}
   */


  function sortListItems(elem, dir) {
    const elements = [...(0, _utils.children)(elem, "li")];
    const sortedElements = elements.sort(makeSorter(dir)).reduce((frag, elem) => {
      frag.appendChild(elem);
      return frag;
    }, document.createDocumentFragment());
    return sortedElements;
  }
  /**
   * Shallow sort a definition list based on its definition terms (dt) elements.
   *
   * @param {HTMLDListElement} dl
   * @returns {DocumentFragment}
   */


  function sortDefinitionTerms(dl, dir) {
    const elements = [...(0, _utils.children)(dl, "dt")];
    const sortedElements = elements.sort(makeSorter(dir)).reduce((frag, elem) => {
      const {
        nodeType,
        nodeName
      } = elem;
      const children = document.createDocumentFragment();
      let {
        nextSibling: next
      } = elem;

      while (next) {
        if (!next.nextSibling) {
          break;
        }

        children.appendChild(next.cloneNode(true));
        const {
          nodeType: nextType,
          nodeName: nextName
        } = next.nextSibling;
        const isSameType = nextType === nodeType && nextName === nodeName;

        if (isSameType) {
          break;
        }

        next = next.nextSibling;
      }

      children.prepend(elem.cloneNode(true));
      frag.appendChild(children);
      return frag;
    }, document.createDocumentFragment());
    return sortedElements;
  }

  function run() {
    /** @type {NodeListOf<HTMLElement>} */
    const sortables = document.querySelectorAll("[data-sort]");

    for (const elem of sortables) {
      let sortedElems;
      const dir = elem.dataset.sort || "ascending";

      switch (elem.localName) {
        case "dl":
          {
            const definition =
            /** @type {HTMLDListElement} */
            elem;
            sortedElems = sortDefinitionTerms(definition, dir);
            break;
          }

        case "ol":
        case "ul":
          {
            const list =
            /** @type {HTMLUListElement} */
            elem;
            sortedElems = sortListItems(list, dir);
            break;
          }

        default:
          (0, _pubsubhub.pub)("warning", "ReSpec can't sort ".concat(elem.localName, " elements."));
      }

      if (sortedElems) {
        const range = document.createRange();
        range.selectNodeContents(elem);
        range.deleteContents();
        elem.appendChild(sortedElems);
      }
    }
  }
});
//# sourceMappingURL=list-sorter.js.map